import { ChoiceGroup } from '@consta/uikit/ChoiceGroup'
import { Select } from '@consta/uikit/Select'
import type { TextPropSize, TextPropView } from '@consta/uikit/Text'
import { Text } from '@consta/uikit/Text'
import { TextField } from '@consta/uikit/TextField'
import type { AlgorithmParams, CommonParams, MLServiceToUseType } from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import {
  aggregationItems,
  cropSizeItems,
  MAX_ITERATIONS,
  MAX_OVERLAP,
  MIN_ITERATIONS,
  MIN_OVERLAP,
  mlServicesItems,
} from '../../../constants'
import css from '../Algorithm.css'
import { handleValueChange } from '../helpers'

function validateNumbers(value: number | string, min: number, max: number) {
  const num = +value
  return num >= min && num <= max
}

type CommonProps = {
  algorithm: AlgorithmParams
  textProps?: { size: TextPropSize; view: TextPropView }
  handleChange: (field: keyof CommonParams, value: string | number | boolean) => void
}

export const Common: FC<CommonProps> = ({ algorithm, textProps, handleChange }) => {
  const formData = algorithm as CommonParams

  const handleNumber = (
    value: Nullable<string>,
    field: keyof CommonParams,
    min: number,
    max: number,
  ) => {
    if (value == null) {
      handleChange(field, '')
      return
    }
    const parsed = value.match(/[+-]?(\d+[.,])?\d+/g)?.[0]

    if (parsed != null && validateNumbers(parsed, min, max)) {
      handleChange(field, parsed)
    }
  }

  return (
    <>
      <div className={css.input}>
        <Text {...textProps}>Размер кропа</Text>
        <Select
          size="xs"
          items={cropSizeItems}
          value={cropSizeItems.find(crop => crop.id === formData.cropSize)}
          onChange={value => {
            handleValueChange<CommonParams>(handleChange, 'cropSize', value?.id)
          }}
        />
      </div>
      <div className={css.input}>
        <Text {...textProps}>Итераций обучения</Text>
        <TextField
          size="xs"
          value={`${formData.iterations}`}
          onChange={value => {
            handleNumber(value, 'iterations', MIN_ITERATIONS, MAX_ITERATIONS)
          }}
        />
      </div>
      {/*<div className={css.input}>*/}
      {/*  <Text {...textProps}>Направление</Text>*/}
      {/*  <Select*/}
      {/*    size="xs"*/}
      {/*    items={directionItems}*/}
      {/*    value={directionItems.find(c => c.id === formData.direction)}*/}
      {/*    onChange={({ value }) => handleValueChange<CommonParams>(handleChange, 'direction', value.id)}*/}
      {/*  />*/}
      {/*</div>*/}
      <div className={css.input}>
        <Text {...textProps}>Перекрытие</Text>
        <TextField
          size="xs"
          type="number"
          value={`${formData.overlap}`}
          step="0.1"
          onChange={value => {
            handleNumber(value, 'overlap', MIN_OVERLAP, MAX_OVERLAP)
          }}
        />
      </div>
      <div className={css.input}>
        <Text {...textProps}>Способ агрегации</Text>
        <Select
          size="xs"
          items={aggregationItems}
          value={aggregationItems.find(item => item.id === formData.aggregation)}
          onChange={value => {
            handleValueChange<CommonParams>(handleChange, 'aggregation', value?.id)
          }}
        />
      </div>
      <ChoiceGroup
        size="xs"
        view="ghost"
        value={formData.mlServiceToUse}
        items={mlServicesItems}
        getItemLabel={(label: MLServiceToUseType) => label}
        multiple={false}
        name="sortGroup"
        onChange={value => {
          handleValueChange<CommonParams>(handleChange, 'mlServiceToUse', value)
        }}
      />
    </>
  )
}
